<template>
  <div
    class="about section"
    :style="sectionStyle"
  >
    <div class="container flex justify-center">
      <div
        v-if="title"
        class="title q-mb-md"
        :style="titleStyle"
      >
        {{ title }}
      </div>

      <div
        v-if="sublabel || description || photoUrl"
        class="row"
      >
        <div
          v-if="sublabel || description"
          class="col-12 col-sm-7"
        >
          <div
            v-if="sublabel"
            :style="sublabelStyle"
            class="sublabel q-mb-lg"
          >
            {{ sublabel }}
          </div>
          <div
            v-if="description"
            :style="descriptionStyle"
            class="description q-mb-lg"
          >
            {{ description }}
          </div>
        </div>
        <div
          v-if="photoUrl"
          class="col-12 col-sm-5 order-xs-first order-sm-last q-pa-lg"
        >
          <img
            :src="photoUrl"
            class="full-width"
          >
        </div>
      </div>

      <CTAButton v-bind="cta"/>
    </div>
  </div>
</template>

<script>
import CTAButton from './CTAButton';
import backgroundMixin from './mixins/backgroundMixin';
import descriptionMixin from './mixins/descriptionMixin';
import popupMixin from './mixins/popupMixin';
import sublabelMixin from './mixins/sublabelMixin';
import titleMixin from './mixins/titleMixin';

export default {
  name: 'AboutSection',
  components: { CTAButton },
  mixins: [
    backgroundMixin,
    titleMixin,
    descriptionMixin,
    sublabelMixin,
    popupMixin,
  ],
  props: {
    photoUrl: {
      type: String,
      default: undefined,
    },
    cta: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.about {
  .sublabel {
    font-weight: 500;
  }
  .description {
    line-height: 35px;
  }
}
</style>
